import React from 'react';
import { Reveal } from './Reveal';

const SectionHeading = ({ overline, title, accent, subtitle, align = 'center', light = false }) => {
  const alignment = align === 'left' ? 'text-left items-start' : 'text-center items-center mx-auto';
  return (
    <Reveal className={`flex flex-col ${alignment} max-w-3xl ${align === 'center' ? 'mx-auto' : ''} mb-16`}>
      {overline && <p className="overline mb-5">{overline}</p>}
      <h2 className={`font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight leading-tight ${light ? 'text-obsidian' : 'text-white'}`}>
        {title}
        {accent && (
          <span className="block text-gradient-blue font-normal">{accent}</span>
        )}
      </h2>
      {subtitle && (
        <p className={`mt-6 text-base sm:text-lg leading-relaxed ${light ? 'text-black/60' : 'text-white/55'} ${align === 'center' ? 'max-w-2xl' : ''}`}>
          {subtitle}
        </p>
      )}
    </Reveal>
  );
};

export default SectionHeading;
